(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-editorial"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LETTER_DELAY  = 50;   // ms between each letter drop-in
    var LETTER_DELAY_OUT = 22; // ms between each letter drop-out (faster exit)
    var HOLD_DURATION = 2400; // ms to hold after fully revealed
    var ANIM_IN_DUR   = 450;  // ms — must match charDropIn duration
    var ANIM_OUT_DUR  = 300;  // ms — must match charDropOut duration

    var el1 = document.querySelector('.about-editorial__subheading .text-1');
    var el2 = document.querySelector('.about-editorial__subheading .text-2');

    if (!el1 || !el2) return;

    // Split text into individual .char spans
    function buildChars(el) {
      var text = el.getAttribute('data-text') || '';
      el.innerHTML = '';
      text.split('').forEach(function (ch) {
        var span = document.createElement('span');
        if (ch === ' ') {
          span.className = 'char is-space';
        } else {
          span.className = 'char';
          span.textContent = ch;
        }
        el.appendChild(span);
      });
    }

    buildChars(el1);
    buildChars(el2);

    // Animate letters in, returns total duration
    function animateIn(el, startDelay) {
      var chars = el.querySelectorAll('.char:not(.is-space)');
      chars.forEach(function (ch, i) {
        ch.classList.remove('anim-out');
        setTimeout(function () {
          ch.classList.add('anim-in');
        }, startDelay + i * LETTER_DELAY);
      });
      return startDelay + chars.length * LETTER_DELAY + ANIM_IN_DUR;
    }

    // Animate letters out, returns total duration
    function animateOut(el, startDelay) {
      var chars = el.querySelectorAll('.char:not(.is-space)');
      chars.forEach(function (ch, i) {
        ch.classList.remove('anim-in');
        setTimeout(function () {
          ch.classList.add('anim-out');
        }, startDelay + i * LETTER_DELAY_OUT);
      });
      return startDelay + chars.length * LETTER_DELAY_OUT + ANIM_OUT_DUR;
    }

    // Reset all chars to invisible (between cycles)
    function resetChars(el) {
      el.querySelectorAll('.char:not(.is-space)').forEach(function (ch) {
        ch.classList.remove('anim-in', 'anim-out');
      });
    }

    var current = el1;
    var next    = el2;

    function cycle() {
      // 1. Animate current out
      var outDone = animateOut(current, 0);

      // 2. Animate next in (slight overlap — starts as current exits)
      var inDone = animateIn(next, 0);

      var swapAt = Math.max(outDone, inDone);

      setTimeout(function () {
        resetChars(current);

        // Flip references
        var tmp = current;
        current = next;
        next    = tmp;

        // Hold, then loop
        setTimeout(cycle, HOLD_DURATION);
      }, swapAt);
    }

    // Kick off: animate text-1 in first, then start the loop
    var firstDone = animateIn(el1, 0);
    setTimeout(function () {
      setTimeout(cycle, HOLD_DURATION);
    }, firstDone);

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LETTER_DELAY  = 50;   // ms between each letter drop-in
    var LETTER_DELAY_OUT = 22; // ms between each letter drop-out (faster exit)
    var HOLD_DURATION = 2400; // ms to hold after fully revealed
    var ANIM_IN_DUR   = 450;  // ms — must match charDropIn duration
    var ANIM_OUT_DUR  = 300;  // ms — must match charDropOut duration

    var el1 = document.querySelector('.custom-hero__highlight .text-1');
    var el2 = document.querySelector('.custom-hero__highlight .text-2');

    if (!el1 || !el2) return;

    // Split text into individual .char spans
    function buildChars(el) {
      var text = el.getAttribute('data-text') || '';
      el.innerHTML = '';
      text.split('').forEach(function (ch) {
        var span = document.createElement('span');
        if (ch === ' ') {
          span.className = 'char is-space';
        } else {
          span.className = 'char';
          span.textContent = ch;
        }
        el.appendChild(span);
      });
    }

    buildChars(el1);
    buildChars(el2);

    // Animate letters in, returns total duration
    function animateIn(el, startDelay) {
      var chars = el.querySelectorAll('.char:not(.is-space)');
      chars.forEach(function (ch, i) {
        ch.classList.remove('anim-out');
        setTimeout(function () {
          ch.classList.add('anim-in');
        }, startDelay + i * LETTER_DELAY);
      });
      return startDelay + chars.length * LETTER_DELAY + ANIM_IN_DUR;
    }

    // Animate letters out, returns total duration
    function animateOut(el, startDelay) {
      var chars = el.querySelectorAll('.char:not(.is-space)');
      chars.forEach(function (ch, i) {
        ch.classList.remove('anim-in');
        setTimeout(function () {
          ch.classList.add('anim-out');
        }, startDelay + i * LETTER_DELAY_OUT);
      });
      return startDelay + chars.length * LETTER_DELAY_OUT + ANIM_OUT_DUR;
    }

    // Reset all chars to invisible (between cycles)
    function resetChars(el) {
      el.querySelectorAll('.char:not(.is-space)').forEach(function (ch) {
        ch.classList.remove('anim-in', 'anim-out');
      });
    }

    var current = el1;
    var next    = el2;

    function cycle() {
      // 1. Animate current out
      var outDone = animateOut(current, 0);

      // 2. Animate next in (slight overlap — starts as current exits)
      var inDone = animateIn(next, 0);

      var swapAt = Math.max(outDone, inDone);

      setTimeout(function () {
        resetChars(current);

        // Flip references
        var tmp = current;
        current = next;
        next    = tmp;

        // Hold, then loop
        setTimeout(cycle, HOLD_DURATION);
      }, swapAt);
    }

    // Kick off: animate text-1 in first, then start the loop
    var firstDone = animateIn(el1, 0);
    setTimeout(function () {
      setTimeout(cycle, HOLD_DURATION);
    }, firstDone);

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vision-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var LETTER_DELAY  = 50;
    var LETTER_DELAY_OUT = 22;
    var HOLD_DURATION = 2400;
    var ANIM_IN_DUR   = 450;
    var ANIM_OUT_DUR  = 300;

    var el1 = document.querySelector('.vision-hero__highlight .vision-hero__text-1');
    var el2 = document.querySelector('.vision-hero__highlight .vision-hero__text-2');

    if (!el1 || !el2) return;

    function buildChars(el) {
      var text = el.getAttribute('data-text') || '';
      el.innerHTML = '';

      text.split('').forEach(function (ch) {
        var span = document.createElement('span');

        if (ch === ' ') {
          span.className = 'vision-hero__char vision-hero__char--space';
        } else {
          span.className = 'vision-hero__char';
          span.textContent = ch;
        }

        el.appendChild(span);
      });
    }

    buildChars(el1);
    buildChars(el2);

    function animateIn(el, startDelay) {
      var chars = el.querySelectorAll('.vision-hero__char:not(.vision-hero__char--space)');

      chars.forEach(function (ch, i) {
        ch.classList.remove('vision-hero__char--out');

        setTimeout(function () {
          ch.classList.add('vision-hero__char--in');
        }, startDelay + i * LETTER_DELAY);
      });

      return startDelay + chars.length * LETTER_DELAY + ANIM_IN_DUR;
    }

    function animateOut(el, startDelay) {
      var chars = el.querySelectorAll('.vision-hero__char:not(.vision-hero__char--space)');

      chars.forEach(function (ch, i) {
        ch.classList.remove('vision-hero__char--in');

        setTimeout(function () {
          ch.classList.add('vision-hero__char--out');
        }, startDelay + i * LETTER_DELAY_OUT);
      });

      return startDelay + chars.length * LETTER_DELAY_OUT + ANIM_OUT_DUR;
    }

    function resetChars(el) {
      el.querySelectorAll('.vision-hero__char:not(.vision-hero__char--space)').forEach(function (ch) {
        ch.classList.remove(
          'vision-hero__char--in',
          'vision-hero__char--out'
        );
      });
    }

    var current = el1;
    var next = el2;

    function cycle() {
      var outDone = animateOut(current, 0);
      var inDone = animateIn(next, 0);
      var swapAt = Math.max(outDone, inDone);

      setTimeout(function () {
        resetChars(current);

        var tmp = current;
        current = next;
        next = tmp;

        setTimeout(cycle, HOLD_DURATION);
      }, swapAt);
    }

    var firstDone = animateIn(el1, 0);

    setTimeout(function () {
      setTimeout(cycle, HOLD_DURATION);
    }, firstDone);
  })();

  } catch(e) { console.error(e); }
})();
})();
